import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { CrownSimple } from "phosphor-react";
import usePremium from "hooks/usePremium";
import "./index.scss";

const PremiumCue = ({ text }) => {
  const { isPremium } = usePremium();

  if (isPremium) return null;

  return (
    <div className="premium-cue">
      <p className="text">
        <CrownSimple size={20} color="#09ba51" />
        {text}
      </p>
      <Link
        to="/advanced"
        className="link"
        target="_blank"
        rel="noopener noreferrer"
      >
        Get Advanced
      </Link>
    </div>
  );
};

PremiumCue.propTypes = {
  text: PropTypes.string.isRequired,
};

export default PremiumCue;
